module.exports = __webpack_public_path__ + "static/Gotham-Book-fba16089581a4ddab8bccaffadde8af0.woff2";